module.exports = __webpack_public_path__ + "img/2025-07-21a_12.e7680df6.jpg";